import React from "react";
import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import { CompactTable } from "components/shared-ui/compact-table/compact-table";
import { Switch } from "components/shared-ui/input/switch/switch";
import { IMFADevice } from "api/entities/mfa";
import { IColumnDefinition } from "components/shared-ui/table/table";
import { MFADeviceMoreOptions } from "./mfa-device-more-options";

export interface IMfaDevicesSectionProps {
  stagedDevices: (IMFADevice | any)[];
  loading?: boolean;
  onAddClick?: () => void;
  canAdd?: boolean;
  onToggleActive: (device: IMFADevice | any) => void;
  onDelete: (idOrIndex: string | number) => void;
  onRefreshCode: (DeviceId: string) => void;
  testId?: string;
}

export default function MfaDevicesSection(props: IMfaDevicesSectionProps) {
  const testId = props.testId ?? "mfa-devices-section";
  const staged = props.stagedDevices || [];

  const columns: IColumnDefinition<any, null>[] = [
    {
      label: "Device Name",
      formatter: (row) => row.name,
      testId: "device-name",
    },
  ];

  columns.push(
    {
      label: "Active",
      formatter: (row) => (
        <Switch
          testId={`device-active-${row.id}`}
          checked={row.active}
          onChange={() => props.onToggleActive(row)}
        />
      ),
      testId: "device-active",
    },
    {
      label: "Actions",
      formatter: (row) => (
        <MFADeviceMoreOptions
          device={row}
          onDelete={props.onDelete}
          onRefreshCodes={props.onRefreshCode}
        />
      ),
      testId: "device-actions",
    },
  );

  return (
    <SidePanelSection title="Configured Devices" testId={testId}>
      <CompactTable<any>
        columns={columns}
        rows={staged}
        loading={props.loading}
        onAddClick={props.canAdd ? props.onAddClick : undefined}
        addButtonCaption={props.canAdd ? "+ Add Device" : undefined}
        rowId={(r, idx) => r.id ?? idx}
        testId={testId + "-table"}
      />
    </SidePanelSection>
  );
}
